import { ContentType } from '@creditsights/api-ui-web';
import { Article, Component } from '../../models';
import { DATE_FORMATS, formatDate } from '../../utils/dateUtils';
import { containsSectorReviewTag, CR_DOCUMENT_REPORT_COMPONENT } from '../../utils/tagUtils';
import { containsPdfContent } from './ArticleContent/ArticleContent.logic';

export const isReadTimeVisible = (article?: Article): boolean =>
  !!article && article.content.components.length > 0 && !containsPdfContent(article.content);

export const calculateReadTime = (wordCount: number, imageCount: number): number => {
  const wordsPerMinute = 275;
  const imagesPerMinute = 4;
  const imageTimeMinutes = imageCount / imagesPerMinute;
  const wordTimeMinutes = wordCount / wordsPerMinute;
  const readTime = Math.round(wordTimeMinutes + imageTimeMinutes);
  return readTime > 0 ? readTime : 1;
};

export const formatReadTime = (readTime: number): string => {
  return `${readTime} minute read`;
};

export const formatDateTime = (article: Article): string =>
  formatDate(
    article.publishDate,
    article.articleType === ContentType.Covenants ? DATE_FORMATS.MONTH_ABBR_DATE : DATE_FORMATS.DATE_TIME
  );

const isRenderableComponent = (component: Component) =>
  component.file?.pdfContent && component.tags.some((tag) => tag.tagId === CR_DOCUMENT_REPORT_COMPONENT);

interface ArticleComponents {
  renderableComponents: Component[];
  relatedComponents: Component[];
}

export const getArticleComponents = (
  components: Component[],
  articleType: ContentType | undefined
): ArticleComponents => {
  if (ContentType.Covenants === articleType) {
    const renderableComponent = components.find((component) => isRenderableComponent(component));
    const relatedComponents = components.filter((component) => component !== renderableComponent);
    return { renderableComponents: renderableComponent ? [renderableComponent] : [], relatedComponents };
  }
  return { renderableComponents: components, relatedComponents: [] };
};

export const overrideArticleComponents = (article: Article, renderableComponents: Component[]): Article => ({
  ...article,
  content: {
    ...article.content,
    components: renderableComponents,
  },
});

export const isSectorReview = ({ id, tags }: Article): boolean => id >= 300000 && containsSectorReviewTag(tags);
